"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../GatewayService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Class intended for use with any of the v4 storage services.  Currently that includes...
 * -math-storage
 *
 * Eventually there will be more.
 */

/**
 * @typedef {Object} StoredItem
 * @property {String} districtKey the district key owning this item
 * @property {String} groupKey group key, usually the owning user's amp id/business key
 * @property {String} itemKey item key, client-determined
 * @property {String} content item content; no media types enforced
 * @property {String} dateCreated when this item was created
 * @property {String} lastUpdated last time this item was updated
 * @property {String} firstOrNewSinceSubmit is this the first thing saved since a submission, apparently
 */
var StorageServiceClient = /*#__PURE__*/function () {
  function StorageServiceClient(gatewayToken) {
    _classCallCheck(this, StorageServiceClient);

    this.clientService = new _GatewayService["default"](gatewayToken);
  }
  /**
   * GET     /item/{groupKey}/{itemKey:.+}
   * Get a single item by specified keys
   * @param {String} groupKey the data partition key for the data; typically the user's business key (aka amp id)
   * @param {String} itemKey the unique (within the groupKey) key to store data under; typically a cardstack key
   * @return {Promise<StoredItem>} A promise resolving to the desired item, or null if it's not found
   */


  _createClass(StorageServiceClient, [{
    key: "getItem",
    value: function getItem(groupKey, itemKey) {
      return this.clientService.get("item/".concat(groupKey, "/").concat(itemKey));
    }
  }, {
    key: "postItem",
    value:
    /**
     * POST    /item/{groupKey}/{itemKey:.+}
     * Post a single item to the keys specified
     * @param {String} groupKey the data partition key for the data; typically the user's business key (aka amp id)
     * @param {String} itemKey the unique (within the groupKey) key to store data under; typically a cardstack key
     * @param {Object} data the data to store
     * @return {Promise<void>}
     */
    function postItem(groupKey, itemKey, data) {
      return this.clientService.post("".concat(groupKey, "/").concat(itemKey), data, {
        headers: {
          'Content-Type': 'text/plain'
        }
      });
    }
  }, {
    key: "deleteItem",
    value:
    /**
     * DELETE  /item/{groupKey}/{itemKey:.+}
     * Delete the item (if any) under the keys specified
     * @param {String} groupKey the data partition key for the data; typically the user's business key (aka amp id)
     * @param {String} itemKey the unique (within the groupKey) key to store data under; typically a cardstack key
     * @return {Promise<void>}
     */
    function deleteItem(groupKey, itemKey) {
      return this.clientService["delete"]("".concat(groupKey, "/").concat(itemKey), {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
  }, {
    key: "listAll",
    value:
    /**
     * GET     /list/{groupKey}/{itemKeyPrefix:.+}
     * List the keys for items found under specified groupKey, and with itemKey prefixed by itemKeyPrefix
     * @param {String} groupKey the data partition key for the data; typically the user's business key (aka amp id)
     * @param {String} itemKeyPrefix the prefix of the item keys to list
     * @return {Promise<String[]>} A promise resolving to an array of Strings of the form groupKey/itemKey
     */
    function listAll(groupKey, itemKeyPrefix) {
      return this.clientService.get("list/".concat(groupKey, "/").concat(itemKeyPrefix));
    }
  }, {
    key: "listRecent",
    value:
    /**
     * GET     /recent/{groupKey}
     * List the keys for items found under specified groupKey, and with itemKey prefixed by itemKeyPrefix
     * @param {String} groupKey the data partition key for the data; typically the user's business key (aka amp id)
     * @param {number} days how many days back to list items for
     * @return {Promise<String[]>} promise resolving to an array of Strings of form groupKey/itemKey for each item found
     */
    function listRecent(groupKey, days) {
      return this.clientService.get("recent/".concat(groupKey), {
        params: {
          'days': days
        }
      });
    }
  }, {
    key: "getAll",
    value:
    /**
     * GET  /all/{groupKey}/{itemKeyPrefix:.+}
     * Get all items found under specified groupKey, and with itemKey prefixed by itemKeyPrefix
     * @param {String} groupKey the data partition key for the data; typically the user's business key (aka amp id)
     * @param {String} itemKeyPrefix the prefix of the item keys to list
     * @return {Promise<StoredItem[]>} A promise resolving to an array of StoredItems found
     */
    function getAll(groupKey, itemKeyPrefix) {
      return this.clientService.get("all/".concat(groupKey, "/").concat(itemKeyPrefix));
    }
  }, {
    key: "deleteAll",
    value:
    /**
     * DELETE     /all/{groupKey}/{itemKeyPrefix:.+}
     * Delete all items found under specified groupKey, and with itemKey prefixed by itemKeyPrefix
     * @param {String} groupKey the data partition key for the data; typically the user's business key (aka amp id)
     * @param {String} itemKeyPrefix the prefix of the item keys to list
     * @return {Promise<void>}
     */
    function deleteAll(groupKey, itemKeyPrefix) {
      return this.clientService["delete"]("all/".concat(groupKey, "/").concat(itemKeyPrefix));
    }
  }, {
    key: "batchGet",
    value:
    /**
     * POST    /batch-get
     * Get a bunch of items at once by exact keys
     * @param {Array<Array<String>>} keys a list of groupKey/itemKey tuples
     * @param {boolean} includeData whether to include the actual data payloads or just get the metadata
     * @return {Promise<?>} promise resolving to a Map of [a string of form groupKey/itemKey] to [if includeData is true
     *   the data, otherwise the created date for the item]
     */
    function batchGet(keys, includeData) {
      return this.clientService.post("batch-get", keys, {
        params: {
          'includeData': includeData
        }
      });
    }
  }, {
    key: "batchGetAll",
    value:
    /**
     * POST    /batch-get-all
     * Get a bunch of items at once by item key prefix
     * @param {Array<Array<String>>} keys a list of groupKey/itemKeyPrefix tuples
     * @param {boolean} includeData whether to include the actual data payloads or just get the metadata
     * @return {Promise<StoredItem[]>} A promise that resolves to an array of StoredItems found
     */
    function batchGetAll(keys, includeData) {
      return this.clientService.post("batch-get-all", keys, {
        params: {
          'includeData': includeData
        }
      });
    }
  }, {
    key: "batchPost",
    value:
    /**
     * POST    /batch-post
     * Post a bunch of items at once.  Can only take a max of 500 items per call.
     * @param {Array<Array<String>>} keysAndData a list of groupKey/itemKey/data tuples
     * @return {Promise<void>}
     */
    function batchPost(keysAndData) {
      return this.clientService.post("batch-post", keysAndData, {});
    }
  }, {
    key: "batchDeleteAll",
    value:
    /**
     * POST    /batch-delete-all
     * Delete a bunch of items at once by item key prefix
     * @param {Array<Array<String>>} keys a list of groupKey/itemKeyPrefix tuples
     * @return {Promise<void>}
     */
    function batchDeleteAll(keys) {
      return this.clientService.post("batch-delete-all", keys, {});
    }
  }]);

  return StorageServiceClient;
}();

var _default = StorageServiceClient;
exports["default"] = _default;